import { serializeQuery } from './api.utils'
import { BaseApi } from './base.api'

export class DictWordApi extends BaseApi {
	constructor() {
		super('api/editor/dict-word')
	}

	async getListDictWords(data) {
		const query = serializeQuery(data)
		const rs = await this.get(`?${query}`)
		return rs
	}

	async lookup(data) {
		const query = serializeQuery(data)
		const rs = await this.get(`/by-word?${query}`)
		return rs
	}

	async create(data) {
		const rs = await this.post(``, data)
		return rs
	}

	async update(data) {
		const rs = await this.put(`/${data.id}`, data)
		return rs
	}

	async remove(data) {
		const rs = await this.delete(`/${data.id}`, data)
		return rs
	}
}
